import $ from "jquery";
import 'jquery-validation';
import { Modal } from 'flowbite';
import _ from "underscore";
import { getRequest } from "../util/util.js";
import COUNTRY_STATES from "../../data/countries.json";

const boatNamesAPIURL = `${location.origin}/umbraco/api/boats/GetAllBoatNames`;

// options with default values
const modalOptions = {
    placement: 'center-center',
    backdrop: 'dynamic',
    backdropClasses:
        'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-2',
    closable: true,
    onHide: () => {
        location.reload();
    },
    onShow: () => {
        //console.log('modal is shown');
    },
    onToggle: () => {
        //console.log('modal has been toggled');
    },
};
// instance options object
const modalInstanceOptions = {
    /* id: 'single-salesforce-form-modal',*/
    override: true
};

/**
 * Initializes tab functionality. Make sure Tab Button components have data-tab="###" matching the 'Id'
 *  of the corresponding of Tab Content 
 *
 * @param {NodeListOf<Element>} tabButtons - Buttons with data-tab attributes
 * @param {NodeListOf<Element>} tabContents - Tab content panels with matching IDs
 * @param {[string]} [activeClasses] - Array of strings for classes for active tab
 * @param {boolean} [useHash=true] - Whether to update URL hash on tab change
 */
export function initializeTabs(tabButtons, tabContents, activeClasses = ["border-secondary-teal", "border-b-4"], useHash = true) {
    function activateTab(tabName) {
        if (!tabName) return;

        tabButtons.forEach(btn => {
            const isActive = btn.dataset.tab === tabName;
            if (isActive) {
                btn.classList.add(...activeClasses);

            }
            else {
                btn.classList.remove(...activeClasses);
            }

        });

        tabContents.forEach(content => {
            content.classList.toggle('hidden', content.id !== tabName);
        });

        if (useHash) {
            history.replaceState(null, '', `#${tabName}`);
        }
    }

    // Detect initial tab from URL (?formTab=tabName or #tabName)
    const urlParams = new URLSearchParams(window.location.search);
    const queryTab = urlParams.get('tab');
    const hashTab = window.location.hash?.replace('#', '');
    const initialTab = queryTab || hashTab;

    if (initialTab) activateTab(initialTab);

    // Add click listeners to all tab buttons
    tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const tabName = btn.dataset.tab;
            activateTab(tabName);
        });
    });
}


var boatsDropDownData = [];

$(function () {
    formvalidcheck();
});

/**
 * Populates States dropdown based on countries dropdown selection
 *
 * @param {string} countryElementId All the elements with the '.country' class.
 * @param {string} stateElementId All the elements with the '.state' class.
 */
function populateStates(countryElementId, stateElementId) {
    var selectedCountryElement = document.getElementById(countryElementId);
    var selectedCountryIndex = selectedCountryElement.selectedIndex - 1;
    var stateElement = document.getElementById(stateElementId);
    if (stateElement) {
        stateElement.length = 0; // Fixed by Julian Woods
        stateElement.options[0] = new Option("State", "");
        stateElement.selectedIndex = 0;
        if (selectedCountryIndex >= 0) {
            var state_arr = COUNTRY_STATES[selectedCountryIndex].states;
            for (var i = 0; i < state_arr.length; i++) {
                stateElement.options[stateElement.length] = new Option(
                    state_arr[i].name,
                    state_arr[i].name
                );
            }
        }
    }

}

/**
 * Populates Countries dropdown
 *
 * @param {string} countryElementClassName All the elements with the '.country' class.
 */
function populateCountries(countryElementClassName) {
    var countryDropdowns = document.getElementsByClassName(countryElementClassName);
    //given the id of the <select> tag as function argument, it inserts <option> tags
    for (var j = 0; j < countryDropdowns.length; j++) {
        var countryElement = countryDropdowns[j];
        countryElement.length = 0;
        countryElement.options[0] = new Option("Country", "-1");
        countryElement.selectedIndex = 0;
        for (var i = 0; i < COUNTRY_STATES.length; i++) {
            countryElement.options[countryElement.length] = new Option(
                COUNTRY_STATES[i].name,
                COUNTRY_STATES[i].name
            );
        }
        //Assigned all countries. Now assign event listener for the states.
        var stateElementId = countryElement.dataset.stateId;
        if (stateElementId) {
            var currentCountryElementId = countryElement.id;
            populateStates(currentCountryElementId, stateElementId);
        }
    }
}

$(document).on("change", ".country", function () {
    var countryElementId = this.id;
    var stateElementId = this.dataset.stateId;
    populateStates(countryElementId, stateElementId);

});

/**
 * Populates boats dropdown
 *
 * @param {string} boatsElementId Boat Select Id.
 */
async function populateBoats(boatsElementId) {
    //given the id of the <select> tag as function argument, it inserts <option> tags
    for (var j = 0; j < document.getElementsByClassName(boatsElementId).length; j++) {
        var boatElement = document.getElementsByClassName(boatsElementId)[j];
        boatElement.length = 0;
        boatElement.options[0] = new Option("Select A Model", "-1");
        boatElement.selectedIndex = 0;
        var boatNames = await getRequest(boatNamesAPIURL);
        _.each(boatNames, function (boat) {
            var option = new Option(boat, boat);
            boatElement.append(option);
        });
    }
}


async function populateDeckYourDockBoats(boatsElementId) {
    //given the id of the <select> tag as function argument, it inserts <option> tags
    var boatElement = document.getElementById(boatsElementId);
    boatElement.options[0] = new Option("Select A Model", "-1");
    boatElement.selectedIndex = 0;

    var boatNames = await getRequest(boatNamesAPIURL);
    var customBoat = "XSTAR S";

    if (!boatNames.includes(customBoat)) {
        var customOption = new Option(customBoat, customBoat);
        boatElement.append(customOption);
    }
    _.each(boatNames, function (boat) {
        var option = new Option(boat, boat);
        boatElement.append(option);
    });
}

/**
 * Submit Form as a JSON
 *
 * @param {FormData} form form object.
 * @param {Function} success_callback callback function on success of submission.
 * @param {Function} error_callback callback function on failure of submission.
 */
function submitFormAsJson(form, success_callback, error_callback) {
    $.ajax({
        url: $(form).attr("action"),
        type: $(form).attr("method"),
        dataType: "json",
        data: $(form).serialize(),
        success: function (result) {
            success_callback(form, result);
        },
        error: function (xhr) {
            error_callback(form, xhr);
        },
    });
}

/**
 * Adds the URL Parameter to existing URL and reloads the page
 * @param {String} URLParameter string to add to the URL
 */
function redirectAfterFormSubmission(URLParameter) {
    let submitFlag = getUrlParameter(URLParameter);
    if (submitFlag === false) {
        if (window.location.href.includes("?")) {
            window.location = window.location.href + "&" + URLParameter + "=1";
        } else {
            window.location = window.location.href + "?" + URLParameter + "=1";
        }
    } else {
        location.reload();
    }
}

/**
 * Redirect the page as submit
 *
 */
function redirectAsSubmit() {
    //const modal = FlowbiteInstances.getInstance('Modal', 'modal-id');
    defaultModal.toggle();
}

/**
 * Trigger success modal by finding the unique modal GUID in the form
 *
 * @param {FormData} form form object.
 */
function triggerSuccessModal(form) {
    var guidValue = $(form).find("input[name='form_modal_guid_value']").val();

    //check if from popup functionality
    const $wrapper = $(form).closest('.popup-salesforce-form-wrapper');
    if ($wrapper.length > 0) {
        const $linkInput = $wrapper.find('input.form_success_link[name="form_success_link"]').first();
        if ($linkInput.length > 0) {
            const rawUrl = $linkInput.data('link') || $linkInput.val() || '';
            const rawTarget = ($linkInput.data('target') || '_self').toString().trim();

            try {
                const url = new URL(rawUrl, window.location.href);
                if (rawTarget === '_blank') {
                    window.open(url.href, '_blank', 'noopener');
                    location.reload();
                } else {
                    window.location.assign(url.href);
                }
                return; 
            } catch (e) {
                console.warn("Invalid success redirect URL:", rawUrl);
                location.reload();
            }
        }
    }

    var modalId = 'single-salesforce-form-modal-' + guidValue;
    const $targetEl = document.getElementById(modalId);
    const modal = new Modal($targetEl, modalOptions, modalInstanceOptions);
    modal.toggle();
    var modalHideButton = 'single-salesforce-form-modal-close-button-' + guidValue;
    const $closeButtonEl = document.getElementById(modalHideButton);
    $closeButtonEl.addEventListener("click", function (e) {
        modal.hide();
    }, { once: true });
}

function triggerDealerSelectModal(form) {
    var guidValue = $(form).find("input[name='form_modal_guid_value']").val();
    var modalId = 'single-salesforce-form-modal-' + guidValue;
    const $targetEl = document.getElementById(modalId);
    const modal = new Modal($targetEl, modalOptions, modalInstanceOptions);
    modal.toggle();
    var modalHideButton = 'single-salesforce-form-modal-close-button-' + guidValue;
    const $closeButtonEl = document.getElementById(modalHideButton);
    $closeButtonEl.addEventListener("click", function (e) {
        modal.hide();
    });
}

/**
 * Trigger Email Signup success modal by finding the unique modal GUID in the form
 *
 * @param {FormData} form form object.
 */
function triggerEmailSuccessModal(form) {
    $("#email-signup-modal-body").hide();
    $(".email-signup-modal-heading").toggleClass("invisible");
    var $successModal = $("#email-signup-success-modal-body");
    $successModal.show();
    var $iframe = $successModal.find("iframe");
    var $video = $successModal.find("video");
    // check if iframe exist
    if ($iframe.length > 0) {
        var oldSrc = $iframe.attr("src");
        $iframe.removeAttr("src");
        // autoPlay media
        $iframe.attr("src", `${oldSrc}&autoplay=1`);
    }
    // check if video exist
    if ($video.length > 0) {
        $video[0].play();
    }
    const $closeButtonEl = document.getElementById(
        "email-signup-modal-close-button"
    );
    $closeButtonEl.addEventListener("click", function (e) {

        // check if iframe exist
        if ($iframe.length > 0) {
            $iframe.removeAttr("src", "");
            // remove autoplay option
            $iframe.attr("src", oldSrc);
        }
        // check if video exist
        if ($video.length > 0) {
            // there is no stop() function instead we pause video and setting
            // current time to 0 sec
            $video[0].pause();
            $video[0].currentTime = 0;
        }
        $(".email-signup-modal-heading").toggleClass("invisible");
    }, { once: true });
}

/**
 * Alert error message on request
 *
 * @param {FormData} form form object.
 * @param {Error} xhr callback function on success of submission.
 */
function alertError(form, xhr) {
    //console.log(form);
    console.log(xhr);
    alert("An unexpected error has occurred.");
}

async function retrieveRecaptchaToken(form) {
    var reCAPTCHA_site_key = $(form).find(".recaptcha_site_key").val();

    return new Promise((resolve) => {
        grecaptcha.ready(function () {
            grecaptcha.execute(reCAPTCHA_site_key, { action: 'submit' }).then(function (token) {
                $(form).find("input[name='RecaptchaToken']").val(token);
                return resolve(token);
            });
        });
    });

}

/**
 * Lead form submission with callback functions
 *
 * @param {FormData} form form object.
 * @param {Function} success_callback callback function on success of submission.
 * @param {Function} error_callback callback function on failure of submission.
 */
async function sfFormSubmissionHandler(form, success_callback, error_callback) {
    $(form).find("button[type='submit']").attr("disabled", true); //Disable submit button

    const reCaptchaToken = await retrieveRecaptchaToken(form);
    $(form).find("input[name='RecaptchaToken']").val(reCaptchaToken);

    var MC_CID = $("#mc_cid").val();
    var country = $(form).find(".country").val();
    var zip = $(form).find(".zip").val();

    var modalGuid = $(form).find("input[name='form_modal_guid_value']").val();

    var clienteleKey = $(form).find(".lead_dealer_clientele_key");
    var dealerNumber = $(form).find(".lead_dealer_number");
    var dealerName = $(form).find(".lead_web_dealer_name");
    var dealerSelectWrapper = $(form).find(".dealer-select-wrapper");

    sfFormUTMParameters(form);

    $(form).find(".uuid").val(MC_CID);

    if (dealerSelectWrapper.length > 0 &&
        dealerNumber.length > 0 &&
        (dealerNumber.val() == null || dealerNumber.val() == "")) {
        getDealers(country, zip).then(
            function (results) {
                if (results.length === 0) {
                    submitFormAsJson(form, success_callback, error_callback);
                    return false;
                }
                else if (results.length === 1) {
                    clienteleKey.val(results[0].uniqueKey);
                    dealerNumber.val(results[0].dealerNumber);
                    dealerName.val(results[0].name);

                    submitFormAsJson(form, success_callback, error_callback);
                    return false;
                }
                else {
                    clienteleKey.val(results[0].uniqueKey);
                    dealerNumber.val(results[0].dealerNumber);
                    dealerName.val(results[0].name);

                    if (dealerSelectWrapper) {
                        let dealerSelectContent =
                            dealerSelectWrapper.find(".dealer-select");
                        dealerSelectContent.empty();
                        for (let i = 0; i < results.length; i++) {
                            let optionId = "dealer_select_option_" + i;
                            let checked = i === 0 ? "checked" : "";


                            var $dealerOptionalHtml = `
                            <div class='rdio rdio-primary dealer-option-wrapper flex items-center mb-4'>
                              <input name="cust_dealer_select"
                              class="w-4 h-4 border-gray-300 focus:ring-2 focus:ring-blue-300 group-[.theme-dark]:focus:ring-blue-600 group-[.theme-dark]:focus:bg-blue-600 group-[.theme-dark]:bg-gray-700 group-[.theme-dark]:border-gray-600"  
                              type="radio"
                              id="${optionId}" 
                              data-dealer-number="${results[i].dealerNumber}"
                              data-dealer-name="${results[i].name}"
                              data-dealer-key="${results[i].uniqueKey}"
                              ${checked} 
                              class='dealer-option' />
                              <div class="ms-2 text-sm font-medium text-gray-900 group-[.theme-dark]:text-stone-400" for="${optionId}">
                                <span class="dealer-name font-transducer font-bold h3 text-uppercase">${results[i].name}</span>
                                <br>
                                <span class="dealer-address text-base font-light font-['Acumin Pro'] leading-7 md:leading-loose'>
                                ${results[i].street}
                                <br>
                                ${results[i].city}, ${results[i].state} ${results[i].zipcode}
                                </span>
                              </div>
                            </div>
                            `.trim()

                            
                            dealerSelectContent.append($dealerOptionalHtml);
                        }
                        $(form)
                            .find("input[type=radio][name=cust_dealer_select]")
                            .change(function () {
                                $(form)
                                    .find(".lead_dealer_clientele_key")
                                    .val($(this).attr("data-dealer-key"));
                                $(form)
                                    .find(".lead_dealer_number")
                                    .val($(this).attr("data-dealer-number"));
                                $(form)
                                    .find(".lead_web_dealer_name")
                                    .val($(this).attr("data-dealer-name"));
                            });
                        $(form).find(".sales-force-form").hide();

                        dealerSelectWrapper.show();
                        dealerSelectWrapper.get(0).scrollIntoView();
                        $(form).find("button[type='submit']").attr("disabled", false); //Disable submit button

                    }
                }
            },
            function () {
                //Failed but still submit
                submitFormAsJson(form, success_callback, error_callback);
                return false;
            }
        );
    } else {
        submitFormAsJson(form, success_callback, error_callback);
        return false;
    }
}

/**
 * Story form submission with callback functions
 *
 * @param {FormData} form form object.
 * @param {Function} success_callback callback function on success of submission.
 * @param {Function} error_callback callback function on failure of submission.
 */
async function sfFormStorySubmissionHandler(form, success_callback, error_callback) {
    $(form).find("button[type='submit']").attr("disabled", true); //Disable submit button

    const reCaptchaToken = await retrieveRecaptchaToken(form);
    $(form).find("input[name='RecaptchaToken']").val(reCaptchaToken);

    var MC_CID = $("#mc_cid").val();
    var country = $(form).find(".country").val();
    var zip = $(form).find(".zip").val();

    var modalGuid = $(form).find("input[name='form_modal_guid_value']").val();

    var clienteleKey = $(form).find(".lead_dealer_clientele_key");
    var dealerNumber = $(form).find(".lead_dealer_number");
    var dealerName = $(form).find(".lead_web_dealer_name");
    var dealerSelectWrapper = $(form).find(".dealer-select-wrapper");

    sfFormUTMParameters(form);

    $(form).find(".uuid").val(MC_CID);

    submitFormAsJson(form, success_callback, error_callback);
    return false;
}

/**
 * Lead form submission without dealers logic.
 *
 * @param {FormData} form form object.
 * @param {Function} success_callback callback function on success of submission.
 * @param {Function} error_callback callback function on failure of submission.
 */
async function sfFormSubmissionHandlerWithoutDealers(form, success_callback, error_callback) {
    $(form).find("input[type='submit']").attr("disabled", true); //Disable submit button
    const reCaptchaToken = await retrieveRecaptchaToken(form);
    $(form).find("input[name='RecaptchaToken']").val(reCaptchaToken);
    var MC_CID = $("#mc_cid").val();
    $(form).find(".uuid").val(MC_CID);
    submitFormAsJson(form, success_callback, error_callback);
}

/**
 * Validating all forms on the site
 *
 */
function formvalidcheck() {
    $("#email-signup_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
        },
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
        },

        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            event.preventDefault();
            $("#email-signup-submit").attr("disabled", true);
            //$(form).find("input[type='submit']").attr("disabled", true);
            //submitFormAsJson(form, triggerEmailSuccessModal, alertError);
            sfFormSubmissionHandler(form, triggerEmailSuccessModal, alertError);
            return false;
        },
    });

    $("#gi_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            Subject__c: {
                required: true,
            },
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Country: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            //boat_serial_number__c: {
            //    required: true,
            //},
            //Comments__c: {
            //    required: true,
            //},
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Subject__c: "Please select an option",
            Country: "Please select a country",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            boat_serial_number__c: "Please enter the boat serial #",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#brochure_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#tdr_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#requestquote_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
            Boat_1_Interest__c: {
                required: true,
            },
        },

        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#events_page_form").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Street: {
                required: true,
            },
            City: {
                required: true,
            },
            State: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Country: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Street: "Address is required",
            City: "City is required",
            State: "State is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Country: "Please select a country",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#ltr_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Event_Name__c: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //},
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Event_Name__c: "Please select a Location",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            //LTRsfFormSubmissionHandler(form, redirectAsSubmit, alertError);
            sfFormSubmissionHandler(form, redirectAsSubmit, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#lecf_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            PostalCode: "Zip is required",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            //LTRsfFormSubmissionHandler(form, redirectAsSubmit, alertError);

            const defaultCountry = "United States";
            var countryInput = '<input type="hidden" hidden class="country" name="Country" value="' + defaultCountry + '" />';
            $("#lecf_mainform").append(countryInput);
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#xstarpoi_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Im_Interested_In__c: {
                required: true,
            },
            Boat_Owner__c: {
                required: true,
            },
            Concierge_Discussion__c: {
                required: true,
            },
            Down_Payment__c: {
                required: true,
            }
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            PostalCode: "Zip is required",
            Phone: "Phone Number is required",
            Im_Interested_In__c: "Model is required",
            Boat_Owner__c: "Please select a value",
            Concierge_Discussion__c: "Please select a value",
            Down_Payment__c: "Please select a value",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            //LTRsfFormSubmissionHandler(form, redirectAsSubmit, alertError);

            //const defaultCountry = "United States";
            //var countryInput = '<input type="hidden" hidden class="country" name="Country" value="' + defaultCountry + '" />';
            //$("#xstarpoi_mainform").append(countryInput);
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#dyd_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            PostalCode: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Phone: {
                required: true,
            },
            Boat_1_Interest__c: {
                required: true,
            },
            //RecaptchaToken: {
            //    required: true
            //}
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Boat_1_Interest__c: "Please select a boat",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#webuildmemories_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            City: {
                required: true,
            },
            Country: {
                required: true,
            },
            Story__c: {
                required: true,
            },



        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            City: "City is required",
            Phone: "Phone Number is required",
            Country: "Country is required",
            Story__c: "Please enter your story",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            //LTRsfFormSubmissionHandler(form, redirectAsSubmit, alertError);

            //const defaultCountry = "United States";
            //var countryInput = '<input type="hidden" hidden class="country" name="Country" value="' + defaultCountry + '" />';
            //$("#xstarpoi_mainform").append(countryInput);
            sfFormStorySubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#careers_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            Subject__c: {
                required: true,
            },
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            PostalCode: {
                required: true,
            },
            Phone: {
                required: true,
            },
            Country: {
                required: true,
            },
            Department__c: {
                required: true
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Country: "Please select a country",
            PostalCode: "Zip is required",
            Phone: "Phone number is required",
            Department__c: "Please enter the department name",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#sf_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Phone: {
                required: true,
            },
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Phone: "Phone number is required",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

    $("#kel_mainform").validate({
        ////If true, the form is not submitted and certain errors are displayed on the console
        //debug:false,
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            FirstName: {
                required: true,
            },
            LastName: {
                required: true,
            },
            Email: {
                required: true,
                email: true,
            },
            Phone: {
                required: true,
            },
            Consumer_s_Purchase_Intent__c: {
                required:true,
            }
        },
        // Specify validation error messages
        messages: {
            FirstName: "First name is required",
            LastName: "Last name is required",
            Email: "Email is required",
            Phone: "Phone number is required",
            Consumer_s_Purchase_Intent__c:"Location  is required"
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, event) {
            sfFormSubmissionHandler(form, triggerSuccessModal, alertError);
            event.preventDefault();
            return false;
        },
    });

}

function EmailSignUpSubmit(e) {
    e.preventDefault();
    var emailId = $("#footer-email-signup-input").val();
    $("#email-signup_email").val(emailId);
    $("#footer-email-signup-input").val("");
    // $("#footer-email-signup-mobile-input").val("");
    var modalId = 'email-signup-modal';
    const $targetEl = document.getElementById(modalId);
    const modal = new Modal($targetEl, modalOptions, modalInstanceOptions);
    formvalidcheck();
    modal.toggle();
    const $closeBtn = document.getElementById("email-signup-modal-close-button");
    $closeBtn.addEventListener("click", () => {
        modal.hide();
    }, { once: true });
}

/**
 * fetches all url parameters in the URL
 *
 * @param {URL} url Input URL with parameters.
 */
function getAllUrlParams(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split("#")[0];

        // split our query string into its component parts
        var arr = queryString.split("&");

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split("=");

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof a[1] === "undefined" ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();

            if (paramName != "") {
                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {
                    // create key if it doesn't exist
                    var key = paramName.replace(/\[(\d+)?\]/, "");
                    if (!obj[key]) obj[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                    }
                } else {
                    // we're dealing with a string
                    if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === "string") {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }
                }
            }
        }
    }

    return obj;
}

$("body").on("click", ".clear-reset", function (event) {
    event.preventDefault();
    let form = $(this).closest("form");
    form
        .find(":input")
        .not(":button, :submit, :reset, :hidden, .ignore-reset")
        .val("")
        .prop("checked", false)
        .prop("selected", false);
    form.validate().resetForm();
    return false;
}); //End of Reset Function

$("#email-signup-modal").on("click", ".clear-reset", function (event) {
    event.preventDefault();
    let form = $(this).closest("form");
    form
        .find(":input")
        .not(":button, :submit, :reset, :hidden, .ignore-reset")
        .val("")
        .prop("checked", false)
        .prop("selected", false);
    $("#email-signup_mainform").validate().resetForm();
    //form.validate().resetForm();
    //formvalidcheck();
    return false;
});

const getUTMParameters = (tab) => {
    var queryString = window.location.search;
    var fullquery = window.location.href;
    let utm_source = "";
    let utm_term = "";
    let utm_campaign = "";
    let utm_medium = "";
    let utm_content = "";

    if ("URLSearchParams" in window) {
        const urlParams = new URLSearchParams(queryString);

        utm_source = urlParams.get("utm_source");
        utm_term = urlParams.get("utm_term");
        utm_campaign = urlParams.get("utm_campaign");
        utm_medium = urlParams.get("utm_medium");
        utm_content = urlParams.get("utm_content");

        //update current values of UTM parameters to new cookie values
        loadUTMParameters();
    } else {
        utm_source = getAllUrlParams(fullquery).utm_source;
        utm_term = getAllUrlParams(fullquery).utm_term;
        utm_campaign = getAllUrlParams(fullquery).utm_campaign;
        utm_medium = getAllUrlParams(fullquery).utm_medium;
        utm_content = getAllUrlParams(fullquery).utm_content;

        //update current values of UTM parameters to new cookie values
        loadUTMParameters;
    }

    //pass cookie values
    if (utm_source == "" || utm_source == null) {
        utm_source = getCookie("utm_source");
    }
    if (utm_term == "" || utm_term == null) {
        utm_term = getCookie("utm_term");
    }
    if (utm_campaign == "" || utm_campaign == null) {
        utm_campaign = getCookie("utm_campaign");
    }
    if (utm_medium == "" || utm_medium == null) {
        utm_medium = getCookie("utm_medium");
    }
    if (utm_content == "" || utm_content == null) {
        utm_content = getCookie("utm_content");
    }
    const UTM_Source_Element = document.querySelector(".utm_source");
    if (UTM_Source_Element != null) {
        UTM_Source_Element.setAttribute("value", utm_source);
    }
    const UTM_Campaign_Element = document.querySelector(".utm_campaign");
    if (UTM_Campaign_Element != null) {
        UTM_Campaign_Element.setAttribute("value", utm_campaign);
    }
    const UTM_Medium_Element = document.querySelector(".utm_medium");
    if (UTM_Medium_Element != null) {
        UTM_Medium_Element.setAttribute("value", utm_medium);
    }
    const UTM_Content_Element = document.querySelector(".utm_content");
    if (UTM_Content_Element != null) {
        UTM_Content_Element.setAttribute("value", utm_content);
    }
};

function sfFormUTMParameters(form) {
    var queryString = window.location.search;
    var fullquery = window.location.href;
    let utm_source = "";
    let utm_term = "";
    let utm_campaign = "";
    let utm_medium = "";
    let utm_content = "";
    var gclid_value = "";

    if ("URLSearchParams" in window) {
        const urlParams = new URLSearchParams(queryString);

        utm_source = urlParams.get("utm_source");
        utm_term = urlParams.get("utm_term");
        utm_campaign = urlParams.get("utm_campaign");
        utm_medium = urlParams.get("utm_medium");
        utm_content = urlParams.get("utm_content");
        gclid_value = urlParams.get("gclid");

        //update current values of UTM parameters to new cookie values
        loadUTMParameters();
    } else {
        utm_source = getAllUrlParams(fullquery).utm_source;
        utm_term = getAllUrlParams(fullquery).utm_term;
        utm_campaign = getAllUrlParams(fullquery).utm_campaign;
        utm_medium = getAllUrlParams(fullquery).utm_medium;
        utm_content = getAllUrlParams(fullquery).utm_content;
        gclid_value = getAllUrlParams(fullquery).gclid_value;

        //update current values of UTM parameters to new cookie values
        loadUTMParameters;
    }

    //pass cookie values
    if (utm_source == "" || utm_source == null) {
        utm_source = getCookie("utm_source");
    }
    if (utm_term == "" || utm_term == null) {
        utm_term = getCookie("utm_term");
    }
    if (utm_campaign == "" || utm_campaign == null) {
        utm_campaign = getCookie("utm_campaign");
    }
    if (utm_medium == "" || utm_medium == null) {
        utm_medium = getCookie("utm_medium");
    }
    if (utm_content == "" || utm_content == null) {
        utm_content = getCookie("utm_content");
    }
    if (gclid_value == "" || gclid_value == null) {
        gclid_value = getCookie("gclid");
    }
    $(form).find(".utm_source").val(utm_source);
    $(form).find(".utm_term").val(utm_term);
    $(form).find(".utm_campaign").val(utm_campaign);
    $(form).find(".utm_medium").val(utm_medium);
    $(form).find(".utm_content").val(utm_content);
    $(form).find(".gclid_value").val(gclid_value);
}

function getDealers(country, zip) {
    let params = {
        Zipcode: zip,
        Country: country,
    };
    //data: { zip: zip, country: country },
    let url = `${location.origin}/umbraco/api/SalesforceAPI/GetDealers`;
    let deferred = $.Deferred();
    let request = $.ajax({
        url: url,
        type: 'GET',
        data: { filter: params, zip: zip, country: country },
        contentType: 'application/json',
    });
    request.done(function (res) {
        //console.log(res);
        deferred.resolve(res);
    });
    request.fail(function () {
        deferred.reject();
    });
    return deferred.promise();
};

$(document).ready(function () {
    populateCountries("country");
    populateBoats("boats-dropdown");
    if ($('#dyd_mainform').length) {
        populateDeckYourDockBoats("dyd-boats-dropdown")
    }

    $(".country").val("United States");
    $(".country").trigger("change");

    //#region Contact page Tab logic
        const salesforceFormTabs = document.querySelectorAll('.salesforce-tab-btn');
        const salesforceFormTabContents = document.querySelectorAll('.salesforce-tab-content');
        initializeTabs(salesforceFormTabs, salesforceFormTabContents, ["border-b-[#B32926]"]);
    //#endregion


    //#region Single Salesforce Form Logic

    var singleSalesForceFormExists = document.getElementsByClassName('single-salesforce-form-wrapper');
    if (singleSalesForceFormExists.length > 0) {
        //looping through forms
        _.each(singleSalesForceFormExists, function (singleForm) {
            var guidValue = singleForm.getElementsByClassName("guid_value").item(0).value;
            var newLeadInputValue = singleForm.getElementsByClassName("new_lead_value").item(0).value;
            var campaignRefValue = singleForm.getElementsByClassName("campaign_ref_value").item(0).value;
            var eventName = singleForm.getElementsByClassName("event_name_hidden_value").item(0).value;
            var launchLead = singleForm.getElementsByClassName("launch_lead_hidden_value").item(0).value;
            var newLeadInputValueTrimmed = newLeadInputValue.replace(" ", "").toLowerCase();

            //update respective modal value
            $('.' + guidValue + '-form-wrapper .sales-force-form input[name="form_modal_guid_value"]').val(guidValue);

            //updating leadsource
            if (newLeadInputValue != "") {
                $('.' + guidValue + '-form-wrapper .sales-force-form input[name="LeadSource"]').val(newLeadInputValue);
            }

            if (newLeadInputValueTrimmed == "liveevent") {
                var eventNameInput = '<input type="hidden" hidden class="event_name__value" name="Event_Name__c" value="' + eventName + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(eventNameInput);
            }

            if (launchLead != "") {
                var launchLeadInput = '<input type="hidden" hidden class="Launch__c" name="Launch__c" value="' + launchLead + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(launchLeadInput);
            }
            if (campaignRefValue != "") {
                var campaignRefInput = '<input type="hidden" hidden class="campaign__ref__value" name="Campaign_Ref__c" value="' + campaignRefValue + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(campaignRefInput);
            }
        });

    }
    //#endregion

    //#region Popup Salesforce Form Logic

    var popUpSalesForceFormButtons = document.getElementsByClassName("popup-salesforce-form-button")
    if (popUpSalesForceFormButtons.length > 0) {
        //looping through forms
        _.each(popUpSalesForceFormButtons, function (popUpFormButton) {
            var guidValue = popUpFormButton.dataset.guid;
            var modalId = 'popup-salesforce-form-modal-' + guidValue;
            const $targetEl = document.getElementById(modalId);
            const modal = new Modal($targetEl, modalOptions, modalInstanceOptions);
           
            popUpFormButton.addEventListener("click", function (e) {
                modal.show();
            }, { once: true });
            var modalHideButton = 'popup-salesforce-form-modal-close-button-' + guidValue;
            const $closeButtonEl = document.getElementById(modalHideButton);
            $closeButtonEl.addEventListener("click", function (e) {
                modal.hide();
            }, { once: true });
        });

    }

    var popUpSalesForceFormExists = document.getElementsByClassName('popup-salesforce-form-wrapper');
    if (popUpSalesForceFormExists.length > 0) {
        //looping through forms
        _.each(popUpSalesForceFormExists, function (popUpForm) {
            var guidValue = popUpForm.getElementsByClassName("guid_value").item(0).value;
            var successLink = popUpForm.getElementsByClassName("form_success_link").item(0);
            var successLinkURL = successLink.dataset.link;
            var successLinkTarget = successLink.dataset.target;
 
            //update respective modal value
            $('.' + guidValue + '-form-wrapper .sales-force-form input[name="form_modal_guid_value"]').val(guidValue);
            if (successLink != "") {
                var successLinkInput = '<input type="hidden" data-link="' + successLinkURL + '" data-target="'+successLinkTarget+'" hidden class="form_success_link" name="form_success_link" value="' + successLinkURL + '" />';
                $('.' + guidValue + '-form-wrapper .sales-force-form').append(successLinkInput);
            }
        });

    }
    //#endregion
});

$(document).on("change", "#qi_Subject__c", function () {
    var value = this.value;
    var $boatSerialInput = document.getElementById("qi__Boat_Serial");
    if (value === "General Inquiry - Customer Service (Boat Parts)") {
        $boatSerialInput.parentElement.classList.remove("hidden");
    } else {
        $boatSerialInput.parentElement.classList.add("hidden");
    }
});

$("#footer-email-signup-input").keypress(function (e) {
    if (e.which == 13) {
        //Enter key pressed
        EmailSignUpSubmit(e);
    }
});
$("#footer-email-signup-input-button").on("click", function (e) {
    EmailSignUpSubmit(e);
});

window.formvalidcheck = formvalidcheck;
window.redirectAsSubmit = redirectAsSubmit;
